import type SearchPrediction from 'data/search-predictions';

export type ListingMatchType = 'address' | 'mls' | 'none';

const hasStreetNumberAndName = (query: string): boolean =>
  /^\s*\d+[A-Za-z0-9-]*\s+[A-Za-z]/.test(query);

// Classifies how a clicked listing matched the query the user typed. Used for logging purposes
export function classifyListingMatch(
  query: string,
  prediction: Pick<SearchPrediction, 'id'>
): ListingMatchType {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) {
    return 'none';
  }

  const mlsNumber = prediction.id.replace(/^listing-/i, '').replace(/\s+/g, '').toLowerCase();
  if (mlsNumber && normalizedQuery.replace(/\s+/g, '').includes(mlsNumber)) {
    return 'mls';
  }

  if (hasStreetNumberAndName(query)) {
    return 'address';
  }

  return 'none';
}

export default classifyListingMatch;
